/**
 * @generated SignedSource<<adeedd20c0a9e824428d4e1585f15676>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonsScreensQuery$variables = {
  facilitySlug: string;
};
export type LessonsScreensQuery$data = {
  readonly facility: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"InstructorListFragment_facility" | "LessonsHeaderFragment_facility" | "LessonsSidebar_facility">;
  } | null | undefined;
  readonly session: {
    readonly " $fragmentSpreads": FragmentRefs<"InstructorListFragment_session" | "LessonsHeaderFragment_session" | "LessonsSidebar_session" | "LessonsSignedOutBanner_session">;
  } | null | undefined;
};
export type LessonsScreensQuery = {
  response: LessonsScreensQuery$data;
  variables: LessonsScreensQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "facilitySlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "facilitySlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singular",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plural",
    "storageKey": null
  },
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibleToMembers",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = [
  (v7/*: any*/),
  (v2/*: any*/)
],
v9 = {
  "alias": "lessonTypeRates",
  "args": null,
  "concreteType": "LessonRateConnection",
  "kind": "LinkedField",
  "name": "rates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LessonRateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LessonRate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allMembershipTypes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ClientTypeConnection",
              "kind": "LinkedField",
              "name": "membershipTypes",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ClientTypeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": (v8/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v13 = [
  {
    "kind": "Variable",
    "name": "facilitySlug",
    "variableName": "facilitySlug"
  }
],
v14 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "bookingWindowDays",
    "storageKey": null
  },
  (v2/*: any*/)
],
v15 = [
  (v2/*: any*/)
],
v16 = {
  "kind": "InlineFragment",
  "selections": (v15/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonsScreensQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LessonsHeaderFragment_facility"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InstructorListFragment_facility"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LessonsSidebar_facility"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LessonsHeaderFragment_session"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InstructorListFragment_session"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LessonsSignedOutBanner_session"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LessonsSidebar_session"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LessonsScreensQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "facility",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FacilityCopyOverrides",
            "kind": "LinkedField",
            "name": "copyOverrides",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NounOverride",
                "kind": "LinkedField",
                "name": "lesson",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NounOverride",
                "kind": "LinkedField",
                "name": "course",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NounOverride",
                "kind": "LinkedField",
                "name": "instructor",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FacilityStartEndTime",
            "kind": "LinkedField",
            "name": "startEndTime",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endTime",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LessonTypeConnection",
            "kind": "LinkedField",
            "name": "lessonTypes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LessonTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LessonType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "index",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "defaultDurationMins",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "bookingType",
                "value": "STANDARD"
              }
            ],
            "concreteType": "GroupSize",
            "kind": "LinkedField",
            "name": "minMaxGroupSize",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "min",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "max",
                "storageKey": null
              }
            ],
            "storageKey": "minMaxGroupSize(bookingType:\"STANDARD\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CourseBucketConnection",
            "kind": "LinkedField",
            "name": "courseBuckets",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CourseBucketEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CourseBucket",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicBookingWindowDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Club",
            "kind": "LinkedField",
            "name": "club",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "calendarStartDay",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportsPublic",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "logoImage",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v5/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Department",
            "kind": "LinkedField",
            "name": "department",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "active",
                    "value": true
                  }
                ],
                "concreteType": "InstructorDepartmentProfileConnection",
                "kind": "LinkedField",
                "name": "instructorProfiles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InstructorDepartmentProfileEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InstructorDepartmentProfile",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StaffProfile",
                            "kind": "LinkedField",
                            "name": "staffProfile",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "profileImage",
                                "plural": false,
                                "selections": (v10/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StaffUser",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "fullName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "firstName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastName",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v13/*: any*/),
                                "concreteType": "InstructorDepartmentProfile",
                                "kind": "LinkedField",
                                "name": "instructorDepartmentProfile",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "headline",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v13/*: any*/),
                                "concreteType": "LessonTypeConnection",
                                "kind": "LinkedField",
                                "name": "lessonTypes",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LessonTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "LessonType",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "archivedAt",
                                            "storageKey": null
                                          },
                                          (v6/*: any*/),
                                          (v9/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "instructorProfiles(active:true)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PrivateLessonsPermissionSet",
            "kind": "LinkedField",
            "name": "privateLessonsPermissionSet",
            "plural": false,
            "selections": (v14/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PublicLessonsPermissionSet",
            "kind": "LinkedField",
            "name": "publicLessonsPermissionSet",
            "plural": false,
            "selections": (v14/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "membershipType",
                    "plural": false,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v15/*: any*/),
                    "type": "Customer",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v15/*: any*/),
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c11c1a30947c6126f77722e4f8589b78",
    "id": null,
    "metadata": {},
    "name": "LessonsScreensQuery",
    "operationKind": "query",
    "text": "query LessonsScreensQuery(\n  $facilitySlug: String!\n) {\n  facility(slug: $facilitySlug) {\n    id\n    ...LessonsHeaderFragment_facility\n    ...InstructorListFragment_facility\n    ...LessonsSidebar_facility\n  }\n  session {\n    ...LessonsHeaderFragment_session\n    ...InstructorListFragment_session\n    ...LessonsSignedOutBanner_session\n    ...LessonsSidebar_session\n  }\n}\n\nfragment CourseBucketFilterControlFragment_facility on Facility {\n  courseBuckets {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  copyOverrides {\n    course {\n      singular\n    }\n  }\n}\n\nfragment DateSelectorControlFragment_facility on Facility {\n  startEndTime {\n    startTime\n    endTime\n  }\n  id\n  publicBookingWindowDays\n  durations\n  club {\n    ...useGetClubStartOfWeekNumberPatron_club\n    id\n  }\n}\n\nfragment DurationBasedFiltersModalFragment_facility on Facility {\n  ...useFacilityStartEndTime_facility\n  ...useFacilityGroupSize_facility\n  ...CourseBucketFilterControlFragment_facility\n  ...DurationFilterControlFragment_facility\n  ...DateSelectorControlFragment_facility\n  ...facilityToScheduleOption_facility\n}\n\nfragment DurationFilterControlFragment_facility on Facility {\n  id\n  durations\n}\n\nfragment FacilityLogoFragment_club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment InstructorCardFragment_facility on Facility {\n  id\n  ...useFacilityLessonBookingDays_facility\n  ...useFacilityInstructorNoun_facility\n}\n\nfragment InstructorCardFragment_session on Session {\n  ...InstructorLessonTypeSelect_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      membershipType {\n        __typename\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment InstructorCardFragment_staffProfile on StaffProfile {\n  id\n  ...InstructorPhotoFragment_staffProfile\n  instructorDepartmentProfile(facilitySlug: $facilitySlug) {\n    headline\n    id\n  }\n  lessonTypes(facilitySlug: $facilitySlug) {\n    edges {\n      node {\n        id\n        archivedAt\n        visibleToMembers\n        ...lessonTypeHasRateForMembershipType_lessonType\n      }\n    }\n  }\n  user {\n    fullName\n    id\n  }\n}\n\nfragment InstructorLessonTypeSelect_session on Session {\n  ...LessonTypeSelect_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      membershipType {\n        __typename\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment InstructorListFragment_facility on Facility {\n  ...InstructorCardFragment_facility\n  department {\n    instructorProfiles(active: true) {\n      edges {\n        node {\n          staffProfile {\n            id\n            ...InstructorCardFragment_staffProfile\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment InstructorListFragment_session on Session {\n  ...InstructorCardFragment_session\n}\n\nfragment InstructorPhotoFragment_staffProfile on StaffProfile {\n  profileImage {\n    publicId: renderingKey\n  }\n  user {\n    fullName\n    firstName\n    lastName\n    id\n  }\n}\n\nfragment LessonTypeFilterOption_lessonType on LessonType {\n  id\n  index\n  name\n  description\n  visibleToMembers\n}\n\nfragment LessonTypeFilter_facility on Facility {\n  ...useFacilityLessonNoun_facility\n  lessonTypes {\n    edges {\n      node {\n        id\n        index\n        visibleToMembers\n        name\n        defaultDurationMins\n        ...lessonTypeHasRateForMembershipType_lessonType\n        ...LessonTypeFilterOption_lessonType\n      }\n    }\n  }\n}\n\nfragment LessonTypeFilter_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      membershipType {\n        __typename\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment LessonTypeSelect_session on Session {\n  ...useGetLessonTypeOptions_session\n}\n\nfragment LessonsFiltersFragment_facility on Facility {\n  id\n  ...useFacilityLessonBookingDays_facility\n  ...LessonTypeFilter_facility\n  ...DateSelectorControlFragment_facility\n  ...useFacilityStartEndTime_facility\n  club {\n    ...useGetClubStartOfWeekNumberPatron_club\n    id\n  }\n}\n\nfragment LessonsFiltersFragment_session on Session {\n  ...LessonTypeFilter_session\n}\n\nfragment LessonsFiltersModalFragment_facility on Facility {\n  ...LessonsFiltersFragment_facility\n}\n\nfragment LessonsFiltersModalFragment_session on Session {\n  ...LessonsFiltersFragment_session\n}\n\nfragment LessonsHeaderFragment_facility on Facility {\n  ...useFacilityLessonNoun_facility\n  ...useGetLessonAgendaFilterBar_facility\n  ...DurationBasedFiltersModalFragment_facility\n  ...LessonsFiltersModalFragment_facility\n  club {\n    name\n    logoImage {\n      publicId: renderingKey\n    }\n    ...FacilityLogoFragment_club\n    id\n  }\n}\n\nfragment LessonsHeaderFragment_session on Session {\n  ...LessonsFiltersModalFragment_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n      }\n      ... on Member {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment LessonsSidebar_facility on Facility {\n  ...LessonsFiltersFragment_facility\n}\n\nfragment LessonsSidebar_session on Session {\n  ...LessonsFiltersFragment_session\n}\n\nfragment LessonsSignedOutBanner_session on Session {\n  ...useIsUserSignedIn_session\n  ...useUserBelongsToCurrentClub_session\n  ...useCurrentClubSlug_session\n}\n\nfragment facilityToScheduleOption_facility on Facility {\n  id\n  slug\n  name\n  type\n  department {\n    type\n    id\n  }\n}\n\nfragment lessonTypeHasRateForMembershipType_lessonType on LessonType {\n  lessonTypeRates: rates {\n    edges {\n      node {\n        allMembershipTypes\n        membershipTypes {\n          edges {\n            node {\n              __typename\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useCurrentClubSlug_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        slug\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useFacilityGroupSize_facility on Facility {\n  minMaxGroupSize(bookingType: STANDARD) {\n    min\n    max\n  }\n}\n\nfragment useFacilityInstructorNoun_facility on Facility {\n  copyOverrides {\n    instructor {\n      plural\n      singular\n    }\n  }\n}\n\nfragment useFacilityLessonBookingDays_facility on Facility {\n  club {\n    supportsPublic\n    id\n  }\n  privateLessonsPermissionSet {\n    bookingWindowDays\n    id\n  }\n  publicLessonsPermissionSet {\n    bookingWindowDays\n    id\n  }\n}\n\nfragment useFacilityLessonNoun_facility on Facility {\n  copyOverrides {\n    lesson {\n      plural\n      singular\n    }\n  }\n}\n\nfragment useFacilityStartEndTime_facility on Facility {\n  startEndTime {\n    startTime\n    endTime\n  }\n}\n\nfragment useGetClubStartOfWeekNumberPatron_club on Club {\n  calendarStartDay\n}\n\nfragment useGetLessonAgendaFilterBar_facility on Facility {\n  ...useFacilityLessonNoun_facility\n  startEndTime {\n    startTime\n    endTime\n  }\n  lessonTypes {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment useGetLessonTypeOptions_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      membershipType {\n        __typename\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useIsUserSignedIn_session on Session {\n  user {\n    __typename\n    id\n  }\n}\n\nfragment useUserBelongsToCurrentClub_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n      }\n      ... on Member {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "77f9374fa1eed8ac32694187a4ab4a02";

export default node;
